import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Link, useHistory } from "react-router-dom";
import Routes from "../../routes";
import {
  DateInput,
  Select,
  BreadCrumbs,
  Error500,
  Stepper,
  PrimaryButton,
  SecondaryButton
} from "../Common";

import Loading from "../Loading";
import LoadingButton from "@mui/lab/LoadingButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  trakrefFontFamily,
  trakrefFontFamilyBold,
} from "../../utils";
import {
  Grid,
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  Divider,
  Stack,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import "../../custom.css";
import { trakrefBlue, Grey1, Grey3, white, Black } from "../../color_utils";
import Enums from "../../enums";
import SiteTable from "./Components/SiteAirTable";
import { dialogBodyStyle, dialogHeaderStyle } from "../../Utils/Util_Components/SiteAirFilterStyle";
import ExitModal from "../Common/CommonModal";
import { TranslateW } from "../../Utils/Languages/Translate";
import useNavigate from "../../hooks/useNavigate";
import useBreadCrumbs from "../../hooks/useBreadCrumbs";
import toast from "react-hot-toast";
// TODO: add localizations
const SiteAirFilterChangeOut = (props) => {
  const [loading, setLoading] = useState(true);
  const [woID, setWoID] = useState(null);
  const [isProcessingSubmission, setIsProcessingSubmission] = useState(false);
  const [isSaveAllowed, setIsSaveAllowed] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [location, setLocation] = useState(null);
  const [serviceCompany, setServiceCompany] = useState(null);
  const [workOrderType, setWorkOrderType] = useState(null);
  const [scheduledDate, setScheduledDate] = useState(null);
  const [regionDivision, setRegionDivision] = useState(null);
  const [createdByUser, setCreatedByUser] = useState(null);

  const [errorLoading, setErrorLoading] = useState(null);
  const [exitModal, setExitModal] = useState(false);
  const [isAbleToExit, setIsAbleToExit] = useState(false);

  const history = useHistory();

  const navigate = useNavigate({
    pageName: "SiteAirFilterChangeOut1"
  });
  const breadCrumbs = useBreadCrumbs({
    path: { id: 'SiteAirFilterChangeOut1', text: "Change Out Air Filter", link: history.location.pathname }
  });

  useEffect(() => {
    setWoID(props.match.params.id);
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          Routes.WorkOrder.Details(props.match.params.id)
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        setLocation(data.locationName);
        setServiceCompany(data.serviceCompany);
        setWorkOrderType(data.workOrderType);
        setScheduledDate(formatDate(data.scheduledDate));
        setRegionDivision(data.regionDivision);
        setCreatedByUser(data.createdByUser);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setErrorLoading(true);
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  const UpdateServiceREF = useRef();

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const closePage = () => {
    let defaultURL = woID ? `/WorkOrder/${props.match.params.id}` : '/WorkOrder';
    navigate.goBack(defaultURL)
  };

  const handleMouseEnter = (e) => {
    const rect = e.target.getBoundingClientRect();
    setPosition({ x: rect.left, y: rect.top - 100 });
    handleMouseOver();
  };


  const saveContent = async () => {
    setIsProcessingSubmission(true);

    const returnedData = UpdateServiceREF.current.submit();

    console.log(`returnedData ${returnedData}`);
    if (returnedData == false) {
      setIsProcessingSubmission(false);
      return;
    } else if (returnedData.WorkItems.length <= 0) {
      toast.error('Please select systems and mark them as "Changed Out" to continue.', { duration: 6000 });
      setIsProcessingSubmission(false);
      return;
    }

    const response = await fetch(
      Routes.ServiceEvent.AddSiteAirFilterChangeOut(),
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(returnedData),
      }
    );

    if (response.status === 200) {
      toast.success("The air filters have been successfully changed out", { duration: 6000 });
      setIsProcessingSubmission(false);
      closePage();
    } else {
      setIsProcessingSubmission(false);
      toast.error("There was an error saving the asset", { duration: 6000 });
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // Format date as 'DD/MM/YYYY'
  };
  if (loading) {
    return (
      <>
        <Loading />
      </>
    );
  }
  if (errorLoading) {
    return <Error500 />;
  }

  return (
    <>
      <div className="stack">
        <div className="stackItem">
          <BreadCrumbs
            path={breadCrumbs.getSortedBreadCrumbs()}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
              maxWidth: "66.5%",
              marginBottom: "2px",
            }}
          >
            <Box
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              {isAbleToExit !== true ? (<Link to={`/WorkOrder/${props.match.params.id}`}>
                <IconButton aria-label="close">
                  <ArrowBackIosIcon fontSize="small" />
                </IconButton>
              </Link>
              ) : (
                <IconButton
                  aria-label="close"
                  onClick={() => setExitModal(true)}
                >
                  <ArrowBackIosIcon
                    fontSize="9"
                    sx={{ color: Grey3, fontSize: 9 }}
                  />
                </IconButton>
              )}
              <Typography
                variant="h5"
                sx={{
                  "&.MuiTypography-root": { fontFamily: trakrefFontFamily },
                }}
                style={{ color: Grey1 }}
              >
                {`Work Order # ${props.match.params.id}`}
                <IconButton onMouseOver={handleMouseEnter}>
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Typography>
            </Box>

            <LoadingButton
              variant="contained"
              loading={isProcessingSubmission}
              onClick={saveContent}
              sx={{
                "& .MuiCircularProgress-root": {
                  color: white,
                  width: "21px !important",
                  height: "21px !important",
                },
                "&.MuiButton-root": {
                  fontFamily: trakrefFontFamilyBold,
                  backgroundColor: trakrefBlue,
                  letterSpacing: "1.2px",
                },
              }}
            >
              <span
                style={{
                  color: isProcessingSubmission ? "transparent" : white,
                }}
              >
                {TranslateW("save")}
              </span>
            </LoadingButton>
          </Box>
          <UpdateService
            ref={UpdateServiceREF}
            isSaveAllowed={(e) => setIsSaveAllowed(e)}
            isAbleToExit={(e) => setIsAbleToExit(e)}
            woID={props.match.params.id}
          />
          <ExitModal
            open={exitModal === true}
            close={() => setExitModal(false)}
            bottom={20}
          >
            <Grid container>
              <Grid
                item
                xs={12}
                lg={12}
                align="center"
                sx={{ margin: "6% 0% 1%" }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    "&.MuiTypography-root": {
                      fontFamily: trakrefFontFamily,
                      fontSize: "1.375rem",
                      color: Grey1,
                    },
                  }}
                  align="center"
                >
                  Are you sure you want to leave this page?
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={12}
                align="center"
                sx={{ marginBottom: "8%" }}
              >
                <Typography
                  variant="paragraph"
                  sx={{
                    "&.MuiTypography-root": {
                      fontFamily: trakrefFontFamily,
                      color: Grey3,
                    },
                  }}
                  align="center"
                >
                  Data you have entered won't be saved.
                </Typography>
              </Grid>
              <Grid item xs={12} lg={12} align="center" marginBottom="3%">
                <PrimaryButton
                  useLargeButton
                  buttonText="Leave this page"
                  onClick={closePage}
                  width={65}
                />
              </Grid>
              <Grid item xs={12} lg={12} align="center" marginBottom="4%">
                <SecondaryButton
                  useLargeButton
                  buttonText="Stay on this page"
                  onClick={() => setExitModal(false)}
                  width={65}
                />
              </Grid>
            </Grid>
          </ExitModal>
        </div>
        <div className="stackItem">
          <Dialog
            open={isHovering}
            onClose={handleMouseOut}
            maxWidth={false}
            PaperProps={{
              style: {
                position: "absolute",
                left: `${position.x}px`,
                top: `${position.y}px`,
              },
            }}
            style={{
              color: white,
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            <DialogContent onMouseLeave={handleMouseOut}>
              <div
                className="stackItem"
                style={{ position: "flex", top: 0, right: 0 }}
              >
                <IconButton
                  aria-label="close"
                  onClick={() => handleMouseOut()}
                >
                  <CloseIcon style={{ fontSize: "16px" }} />
                </IconButton>
              </div>
              <Grid container direction={"row"} marginBottom={-2}>
                <div className="text-item">
                  <Typography sx={dialogHeaderStyle}>
                    SERVICE COMPANY
                  </Typography>
                  <Typography sx={dialogBodyStyle}>
                    {serviceCompany}
                  </Typography>
                  <Typography sx={dialogHeaderStyle}>LOCATION</Typography>
                  <Typography sx={dialogBodyStyle}>{location}</Typography>
                </div>
                <Divider
                  orientation={"vertical"}
                  flexItem
                  sx={{ marginLeft: "30px", marginRight: "30px" }}
                />
                <div className="text-item">
                  <Typography sx={dialogHeaderStyle}>REGION</Typography>
                  <Typography sx={dialogBodyStyle}>
                    {regionDivision}
                  </Typography>
                  <Typography sx={dialogHeaderStyle}>
                    WORK ORDER TYPE
                  </Typography>
                  <Typography sx={dialogBodyStyle}>
                    {workOrderType}
                  </Typography>
                </div>
                <Divider
                  orientation={"vertical"}
                  flexItem
                  sx={{ marginLeft: "30px", marginRight: "30px" }}
                />
                <div className="text-item">
                  <Typography sx={dialogHeaderStyle}>
                    DATE SCHEDULED
                  </Typography>
                  <Typography sx={dialogBodyStyle}>
                    {scheduledDate}
                  </Typography>
                  <Typography sx={dialogHeaderStyle}>
                    STORE CONTACT
                  </Typography>
                  <Typography sx={dialogBodyStyle}>
                    {createdByUser}
                  </Typography>
                </div>
                <Grid marginRight={"80px"} />
              </Grid>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </>
  );
};

const UpdateService = forwardRef((props, ref) => {
  const [primaryTechnician, setPrimaryTechnician] = useState(null);
  const [serviceDate, setServiceDate] = useState(null);
  const [technicians, setTechnicians] = useState([]);
  const [tableData, setTableData] = useState(null);
  const [assets, setAssets] = useState([]);
  const [primaryTechError, setPrimaryTechError] = useState(null);
  const [serviceDateError, setServiceDateError] = useState(null);
  const [woID, setWoID] = useState(props.woID);
  const underRepairID = Enums.SE.CoolingApplianceStatus.UnderRepair;
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (primaryTechnician != null && serviceDate != null) {
      props.isSaveAllowed(true);
    }
  }, [primaryTechnician, serviceDate]);

  //isExitModalAllowed
  useEffect(() => {
    if (primaryTechnician !== null || serviceDate !== null) {
      props.isAbleToExit(true);
    }
  }, [primaryTechnician, serviceDate]);


  const fetchData = async () => {
    try {
      const response = await fetch(
        Routes.ServiceEvent.SiteLeakInspectionDropdown(woID)
      );
      const info = await response.json();

      const Techs = info.siteLeak_Technicians.filter(
        (obj) => obj.validCertificateNumber === true
      );
      const sorted = Techs.sort((a, b) =>
        a.name.split(" ")[1].localeCompare(b.name.split(" ")[1])
      );
      const cleanedAssets = info.coolingAppliance.map(({ asset }) => ({
        ...asset,
      }));

      setTechnicians(sorted);
      for (let index = 0; index < cleanedAssets.length; index++) {
        const element = cleanedAssets[index];
        if (!element.tagNumber) {
          cleanedAssets[index].tagNumber = "";
        }
        if (!element.serialNumber) {
          cleanedAssets[index].serialNumber = "";
        }
      }
      setAssets(
        cleanedAssets.map((obj) => ({
          ...obj,
          isExpanded: false,
          isExpandable: false,
          isChecked: false,
          status: obj.coolingAppliance.coolingApplianceStatusId === underRepairID ? "PENDING" : "No Changes",
        }))
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Can not fetching data", { duration: 6000 });
    }
  };

  const clean_WorkItems = (data) => {
    if (data === null || data === undefined) {
      console.log("data is null here");
      return false;
    }
    return data;
  };

  const validate = () => {
    var isValid = true;
    if (primaryTechnician === null || primaryTechnician === "") {
      setPrimaryTechError(true);
      isValid = false;
    }
    if (serviceDate === null || serviceDate === "") {
      setServiceDateError(true);
      isValid = false;
    }
    return isValid;
  };

  useImperativeHandle(ref, () => ({
    submit() {
      if (validate() === false) {
        toast.error("There was an error saving the asset", { duration: 6000 });
        return false;
      } else {
        var cleanWorkItem = clean_WorkItems(tableData);
        if (cleanWorkItem !== false) {
          return {
            ID: woID,
            WorkItemTypeID: 17, // AirFilterChangeOut
            PrimaryTechnicianID: primaryTechnician,
            ServiceDate: serviceDate,
            WorkItems: cleanWorkItem,
          };
        } else {
          toast.error(
            'Please select systems and mark them as "No Leak Found" to continue.', { duration: 6000 }
          );
          return false;
        }
      }
    },
  }));


  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          maxWidth: "65%",
          ml: "26px",
        }}
      >
        <Grid item xs={12}>
          <Stepper
            activeStep={0}
            steps={["1. Update Service"]}
            onStepChange={() => { }}
            hideStepCount
            sx={{
              gap: "15px",
              marginBottom: "25px",
            }}
          />
          <Grid container spacing={6} sx={{ marginBottom: "20px" }}>
            <Grid item xs={6} md={6}>
              <Stack spacing={3}>
                <Select
                  required
                  value={primaryTechnician}
                  label={TranslateW("serviceEventView.primary-technician").toUpperCase()}
                  variant="filled"
                  options={technicians}
                  error={primaryTechError}
                  onChange={(e) => setPrimaryTechnician(e.target.value)}
                />
              </Stack>
            </Grid>
            <Grid item xs={6} md={6}>
              <Stack spacing={3}>
                <DateInput
                  variant="filled"
                  allowPast
                  allowFuture={false}
                  label={`${TranslateW("serviceEventView.service-date").toUpperCase()} *`}
                  date={serviceDate}
                  error={serviceDateError}
                  onChange={(new_date) => setServiceDate(new_date)}
                />
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        fullWidth
        sx={{
          maxWidth: "65%",
          ml: "26px",
          mt: "8px"
        }}
      >
        <Grid item>
          <Typography
            sx={{
              fontFamily: trakrefFontFamily,
              color: Grey1,
              fontSize: "13px",
            }}
          >
            Select the air filters systems below and mark them as « Changed Out
            »
          </Typography>
        </Grid>
        <Grid
          item
          width={"100%"}
          sx={{
            marginTop: "8px",
          }}
        >
          <SiteTable dataUpdated={(e) => setTableData(e)} woID={woID} />
        </Grid>
      </Grid>
    </>
  );
});

export default SiteAirFilterChangeOut;
